import Route from '@ember/routing/route';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';
import BuyerOnlyRouteMixin from 'sh-www/mixins/buyer-only-route-mixin';

class BrandSignupPaymentMethodRoute extends Route.extend(BuyerOnlyRouteMixin) {
  setupController(controller) {
    super.setupController(...arguments);

    const directAssignmentDraftUUID = sessionStorage.getItem('directAssignmentDraftId');

    if (directAssignmentDraftUUID) {
      controller.loadDirectAssignmentFreelancer.perform(directAssignmentDraftUUID);
    }
  }

  resetController(controller, isExiting) {
    super.resetController(...arguments);

    if (isExiting) {
      controller.loadDirectAssignmentFreelancer.cancelAll({ resetState: true });
    }
  }

  activate(transition) {
    super.activate(...arguments);
    trackPageViewFromTransition(this, transition, '/brand/signup/step/payment-method/');
  }
}

export default BrandSignupPaymentMethodRoute;
